<template lang="pug">
    .container(ref='container')
        .animated-scroll(
            ref='animatedScroll'
            )
            svg(width='100%' height='100%' viewBox='0 0 1280 720' preserveAspectRatio='xMidYMid meet')
                g.piece
                    path(d='M757.24 191.4C731.35 233.07 701.45 281.15 700.59 282.32C699.06 284.38 688.33 249.15 688.33 249.15C688.33 249.15 647.5 283.49 622.49 302.75L620.62 301.83V306.9H801.97V191.4H757.24Z' fill='black')
                g.piece
                    path(d='M688.86 191.4V171L673.86 156H599.98L584.98 171V191.4H483.99C529.27 221.19 578.8 254.21 578.8 254.21L513.69 249.15L622.49 305.75C647.5 286.49 684.5 261 684.5 261C684.5 261 697.5 285 699.5 288.5C700.36 287.33 739.61 233.07 765.5 191.4H688.86ZM670 191.4H603.83V183.54L613.19 173.24H660.64L670 183.54V191.4Z' fill='black')
                g.piece
                    path(d='M633 299.5V306.9H477V191.4H491.5C536.78 221.19 594.5 258.5 594.5 258.5L535 256L633 299.5Z' fill='black')
                g.piece
                    path(d='M629.07 325V440.33L485 440.5C506.94 419.93 529.76 397.82 529.76 397.82L542.78 421.68L624.71 325H629.07Z' fill='black')
                g.piece
                    path(d='M650 325V440.33L794.15 440.21C772.21 419.64 749.31 397.83 749.31 397.83L736.29 421.69L654.37 325H650Z' fill='black')
                g.piece
                    path(d='M629 325L543.5 430.8L529.5 410.3C529.5 410.3 515.5 422.3 494.94 440.51H477V325.2L533.06 325V343.89H573.62V325.09L629 325Z' fill='black')
                g.piece
                    path(d='M650.07 325L735.57 430.8L749.57 410.3C749.57 410.3 763.24 422.01 783.8 440.22H802.07V325.2L746.01 325V343.89H705.45V325.09L650.07 325Z' fill='black')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

//import * as basicScroll from 'basicscroll';

export default {
    props: {
        rows: {
            type: String
        },
        modifierClass: String,
        settings: Object,
        isActive: Boolean
    },
    data() {
        return {
            innerBlockPosition: 'top',
            isControlScroll: true
        };
    },
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.scrollHandler();
            this.createScroll();
        },
        createTimeline() {
            let pieces = this.$refs.container.querySelectorAll('.piece');
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .set(pieces, {x: 0, y: 0, scale: 1, rotate: 0})
                .fromTo(pieces[0], {x: 0, y: 0, scale: 1, rotate: 0}, {x: 500, y: -200, scale: 1.7, transformOrigin: '50% 50%', rotate: 10}, 0)
                .fromTo(pieces[1], {x: 0, y: 0, scale: 1, rotate: 0}, {x: 0, y: -180, scale: 2, transformOrigin: '50% 50%', rotate: 20}, 0)
                .fromTo(pieces[2], {x: 0, y: 0, scale: 1, rotate: 0}, {x: -190, y: -150, scale: 1.6, transformOrigin: '50% 50%', rotate: 15}, 0)
                .fromTo(pieces[3], {x: 0, y: 0, scale: 1, rotate: 0}, {x: -350, y: 160, scale: 2, transformOrigin: '50% 50%', rotate: -20}, 0)
                .fromTo(pieces[4], {x: 0, y: 0, scale: 1, rotate: 0}, {x: 200, y: 190, scale: 1.9, transformOrigin: '50% 50%', rotate: -10}, 0)
                .fromTo(pieces[5], {x: 0, y: 0, scale: 1, rotate: 0}, {x: 0, y: 230, scale: 2.1, transformOrigin: '50% 50%', rotate: -30}, 0)
                .fromTo(pieces[6], {x: 0, y: 0, scale: 1, rotate: 0}, {x: 200, y: 200, scale: 2.3, transformOrigin: '50% 50%', rotate: 20}, 0);
            this.timeline.progress(0.0001);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 200vh;
    position: relative;
    overflow: hidden;
}

.animated-scroll {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    width: 100%;
    height: 100vh;
    background-color: var(--color-red);
}
</style>
